import { Student } from '../../_models/student';
import { Batch } from '../../_models/batch';
import { TimetableTemplate } from './../../_models/timetable-template';
import { first } from 'rxjs/operators';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { User } from '../../_models';
import { LessonPlan } from './../../_models/lesson-plan';
import { LessonPlanStepStatus } from './../../_models/lesson-plan-step-status';
import Config from '../../_config/config';
import { RouteComponentProps } from 'react-router';
import React from 'react';
import ApiService from '../../_services/ApiService';
import AuthenticationService from '../../_services/AuthenticationService';
import StudentService from '../../_services/StudentService';
import BatchService from '../../_services/BatchService';
import TimeTableService from '../../_services/TimeTableService';
import DialogService from '../../_services/DialogService';
import LessonPlanService from '../../_services/LessonPlanService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AlertDialog } from '../../_components/alert-dialog/AlertDialog';
// import {DbService} from '../../_services/DbService';

interface MyProps extends RouteComponentProps {
   
}

interface MyStates {
    batches:Array<Batch>,
    loadingProgress: number,
    loadingText: string,
    showAlert:boolean,
    alertMessage:string,
    confirmId:number
}
export class SyncIn  extends React.Component<MyProps,MyStates> {
  
  state:MyStates={
      batches:[],
      loadingProgress:0,
      loadingText: '',
      showAlert:false,
      alertMessage:'',
      confirmId:-1
    }  
  currentUser: User; 


  instructorId: number;
  students: Student[];
  batchIds: number[] = [];
  syncConfigArray: any = [];
  syncConfigIndex: number = 0;
  SYNC_CONFIG: any = {};
  // dbservice:DbService = new DbService()
  studentservice:StudentService = new StudentService()
  timetableservice:TimeTableService = new TimeTableService()
  lessonplanservice:LessonPlanService = new LessonPlanService()
  batchservice:BatchService = new BatchService()

  constructor(
    props:MyProps
    ) {
        super(props)
      this.currentUser = AuthenticationService?.currentUserValue;
      this.instructorId = this.currentUser?.instructorId;
      this.handleAlert = this.handleAlert?.bind(this)
   }
   componentDidMount():void{
    //  console.log()
    this.initSync();
   }

  addToDo(): void {
        this.studentservice.addStudent('Student3','s3',3).then(() => {
      console.log("Added Student...");
    });
  }

  getStudents(): void {
    this.studentservice.getStudentsForBatch(3).then(
      students => {
          this.students = students;
          console.log(students);
      },
      error => {
          console.log(error);
      }
    );
  }

  initSync(): void {
    this.setState({loadingText: "Synchronizing"})
    ApiService.initSync()
      .then(
        respData => {
          console.log('initSync(), Response : '+JSON.stringify(respData.data));
          console.log('SuccessCB');
          if(respData.data.status===1) {
            localStorage.setItem('initData', JSON.stringify(respData.data.data));
            this.SYNC_CONFIG = respData.data.data;
            localStorage.setItem('lastSyncInDate', respData.data.data.syncDateTime);
            /*if(VERSION_NAME!=respData.data.syncVersion) {
              alert("Application running on Older Version !!!\nkindly upgrade and try again.");
            }
            else {
              this.initSyncConfig();            
              //this.syncBatchesAPI();
            }*/
            this.initSyncConfig();             
          }
          else {
            this.setState({confirmId:1})
            this.showAlertDialog(respData.data.message);   
          }
        })
        .catch(
            error => {
                //this.alertService.error(error);
                console.log(error);
                this.setState({confirmId:2})
                this.connectionError();
              }
        )
       
  }

  initSyncConfig() {
    console.log("this.globalVars.CONFIG.attendanceEnableStatus : "+this.SYNC_CONFIG.attendanceEnableStatus);
    if(this.SYNC_CONFIG.attendanceEnableStatus==true) {
      console.log("this.globalVars.CONFIG.attendanceEnableStatus : "+this.SYNC_CONFIG.attendanceEnableStatus);
      this.syncConfigArray.push("attendance");
    }
    if(this.SYNC_CONFIG.lessonplanEnableStatus==true) {
      console.log("this.globalVars.CONFIG.lessonplanEnableStatus : "+this.SYNC_CONFIG.lessonplanEnableStatus);
      this.syncConfigArray.push("lessonplan");
    }
    /*if(this.SYNC_CONFIG.testDataEntryEnableStatus==true) {
      console.log("this.globalVars.CONFIG.testDataEntryEnableStatus : "+this.SYNC_CONFIG.testDataEntryEnableStatus);
      this.syncConfigArray.push("testdataentry");
    }
    if(this.SYNC_CONFIG.tagsEnableStatus==true) {
      console.log("this.globalVars.CONFIG.tagsEnableStatus : "+this.SYNC_CONFIG.tagsEnableStatus);
      this.syncConfigArray.push("tags");
    }*/
    this.syncBatchesAPI();
  }

  
  syncBatchesAPI() {
    console.log('syncBatchesAPI()...');
    this.setState({loadingProgress : 10});
    this.setState({loadingText:"Synchronizing Batches..."})  
    ApiService.syncBatches(this.instructorId)
    .then(
      respData => {
        console.log('syncBatches(), Response : '+JSON.stringify(respData.data));
        if(respData.data.status==1) {
          if(respData.data.data.length>0) {
            this.setState({batches : respData.data.data},()=>{
              
            });
            /*batches.forEach(function(batch) {
              let _batch = {
                'id': parseInt(batch.id),
                'name': batch.name,
                'schoolId': parseInt(batch.schoolId),
                'schoolName': batch.schoolName,
                'courseId': parseInt(batch.courseId),
                'courseName': batch.courseName,
              }
              batchesToSync.push(_batch);
            });*/           
            this.syncBatchesToDB();
          }
          else {
            this.syncTimetables();
            this.setState({confirmId:3})
            // this.showAlertDialog("No Batches found.");  
          }
        }
        else {
          this.setState({confirmId:3})
          this.showAlertDialog(respData.data.message);   
        }
      },
      error => {
        //this.alertService.error(error);
        console.log(error);
        this.setState({confirmId:2})
        this.connectionError(); 
      }
    );
  }

  syncBatchesToDB() {
    console.log('syncBatchesToDB()...');
    this.batchservice.addBatches(this.state.batches).then(data => {            
        this.syncStudents();
      },
      error => {
        this.setState({confirmId:4})
        this.showAlertDialog('Added batches Error:'+ error)  
        console.log('Added batches Error:'+ error);
      }
    );
  }

  syncStudents() {
    this.setState({loadingProgress : 12});
    this.setState({loadingText:"Synchronizing Students..."})
    this.syncStudentsBatchWise(0);
  }

  syncStudentsBatchWise(index:number) {
    console.log('syncStudentsBatchWise()...');
    this.setState({loadingProgress : this.state.loadingProgress+Math.round(10/this.state.batches.length)});
    this.setState({loadingText:"Synchronizing students for batch "+this.state.batches[index].name+"..."})
    this.syncStudentsAPI(index);     
  }

  syncStudentsAPI(index: number) {
    console.log('syncStudentsAPI()...');
    ApiService.syncStudentsForBatch(this.state.batches[index].id)
    .then(
      respData => {
        console.log('syncStudentsAPI(), Response : '+JSON.stringify(respData.data));
        /*
          {"data.":1,"message":"Success",
          "data":[{"enrollmentId":"7332","name":"Harshit SHARMA","studentCode":"126190011","batchId":"219"}
        */
        if(respData.data.status==1) {
            let studentsToSync: Array<Student> = [];
            let students: any = respData.data?.data;
            students.map((student) => {
              let _student = {
                'id': parseInt(student.enrollmentId),
                'name': student.name,
                'studentCode': student.studentCode,
                'batchId': parseInt(student.batchId)
              }
              studentsToSync.push(_student);
            });
            console.log("Students to sync: "+JSON.stringify(studentsToSync));
            this.syncStudentsToDB(studentsToSync, index);
        }
        else {
          this.setState({confirmId:3})
          this.showAlertDialog(respData.data.message);   
        }
      },
      error => {
        //this.alertService.error(error);
        console.log(error);
        this.setState({confirmId:3})
        this.connectionError();
      }
    );
  }

  syncStudentsToDB(studentsToSync: Array<Student>, index: number) {
    console.log('syncStudentsToDB()...');
    this.studentservice.addstudents(studentsToSync).then(data => { 
        index++;
        if(index<this.state.batches.length){
          this.syncStudentsBatchWise(index);  
        }
        else {
          this.syncTimetables();
          console.log("Students Synced successfully...");
        }
      },
      error => {
        this.setState({confirmId:3})
        this.showAlertDialog('Add Students Error:'+ error)  
        console.log('Add Students Error:'+ error);
      }
    );
  }

  proceedSync() {
    console.log("In proceedSync : "+this.syncConfigArray.length);
    if(this.syncConfigIndex<this.syncConfigArray.length) {
      let nextSync = this.syncConfigArray[this.syncConfigIndex];
      this.syncConfigIndex++;
      switch (nextSync) {
        case "attendance":
          this.setState({loadingProgress : 40});
          this.syncAttendanceData();
          break;
        case "lessonplan":
          this.setState({loadingProgress : 60});
          this.syncLessonPlanData();
          break;
        /*case "testdataentry":
          this.loadingProgress = 70;
          this.syncTestData();
          break;
        case "tags":
          this.loadingProgress = 95;
          this.syncTagData();
          break;*/
      }
    }
    else {
      this.setState({loadingProgress : 100});
      this.syncSuccess();
    }
        
  }

  syncAttendanceData() {
    this.syncTimetables()
  }

  syncLessonPlanData() {
    this.syncLessonPlans();  
  }

  syncTimetables() {
    console.log('syncTimetables()...');
    this.setState({loadingProgress : this.state.loadingProgress+10});
    this.setState({loadingText:"Synchronizing Timetables..."})
    let batchIds:number[]=[];
    this.state.batches.map((batch) => {
      batchIds.push(batch.id);    
    });
    console.log('syncTimetables(); '+JSON.stringify(batchIds));
    ApiService.syncTimeTables(this.instructorId, batchIds)
    .then(
      respData => {
        /*
          "data":[
            {"name":"b1_16/3/20-30/04/2020_2","activitySlotTemplates":[
            {"id":2976,"date":"07/04/2020","topicId":72,"topicName":"Chemistry","instructorId":114,"startTime":"05:00","endTime":"06:00","batchId":219},
            {"id":2977,"date":"08/04/2020","topicId":72,"topicName":"Chemistry","instructorId":114,"startTime":"05:00","endTime":"06:00","batchId":219},
            {"id":2978,"date":"16/04/2020","topicId":72,"topicName":"Chemistry","instructorId":114,"startTime":"05:00","endTime":"06:00","batchId":219}],
            "id":290,
            "batchId":219,"isActive":1,
            "timetableBatchMappings":[{"timetableId":290,"batchId":219}]}]}
        */
        console.log('syncTimetables(), Response : '+JSON.stringify(respData.data));
        if(respData.data.status===1) {
          console.log("inside if status === 1")
          if(respData.data.data.length>0) {
            console.log("inside if length > 0")
            let timetablesToSync: Array<TimetableTemplate> = respData.data.data;
            this.syncTimetablesToDB(timetablesToSync);
          }
          else {
            //this.showAlertDialog("No Timetables found.");
            this.setState({confirmId:10},()=>{
              this.handleAlert(true)
            })
              // this.showAlertDialog("No Timetables found.")
            //   console.log('User confirmed:', confirmed)
            // }
            // else{
            //   console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
            //   this.proceedSync();
            // }
          }
        }
        else {
          this.setState({confirmId:3})
          this.showAlertDialog(respData.data.message);   
        }        
      },
      error => {
        //this.alertService.error(error);
        console.log(error);
        this.setState({confirmId:2})
        this.connectionError();
      }
    );
  }

  syncTimetablesToDB(timetablesToSync: Array<TimetableTemplate>) {
    console.log('syncTimetablesToDB()...');
    this.timetableservice.addTimetables(timetablesToSync).then(data => {              
        console.log("syncTimetablesToDB : successCB...")
        this.proceedSync();
      },
      error => {
        this.setState({confirmId:3})
        this.showAlertDialog('Sync Timbetables Error:'+ error)  
        console.log('Sync Timbetables Error:'+ error);
      }
    );
  }

  syncLessonPlans() {    
    console.log('syncLessonPlans()...');
    this.setState({loadingProgress : this.state.loadingProgress+10});
    this.setState({loadingText:"Synchronizing Lesson Plans..."})
    ApiService.syncLessonPlans(this.instructorId)
    .then(
      respData => {
        /*
          "data":[
            {"batches":[219,88,117,3,49],
          "code":"asdf",
          "topics":[76,72],
          "sortOrder":"null","name":"aasdf","id":"298",
          "lessonPlanSteps":[
            {"id":25,"name":"MATHS","code":"go2","lessonPlanId":"298","startDate":null,"endDate":null,"noOfDays":"0","remarks":"","attachments":[]}
          ],"data.":"0"},
          {"batches":[116],
          "code":"go2",
          "topics":[106],
          "sortOrder":"1","name":"MATHS","id":"348",
          "lessonPlanSteps":[
            {"id":195,"name":"dfBu 'kCnkFkZ gy","code":"stepcode31","lessonPlanId":"348","startDate":"3/4/19","endDate":"31/1/20","noOfDays":"0","remarks":"","attachments":[]},
            {"id":178,"name":"ç'u&mÙkj ij ppkZ","code":"stepcode9","lessonPlanId":"348","startDate":"3/4/19","endDate":"31/1/20","noOfDays":"0","remarks":"","attachments":[]},
            {"id":184,"name":" ç'u&mÙkj ij ppkZ","code":"stepcode16","lessonPlanId":"348","startDate":"3/4/19","endDate":"31/1/20","noOfDays":"0","remarks":"","attachments":[]}
          ],"data.":"0"}
        ]
        */
        console.log('syncLessonPlans(), Response : '+JSON.stringify(respData.data));
        if(respData.data.status===1) {
          if(respData.data.data.length>0) {
            let lessonPlansToSync: Array<LessonPlan> = respData.data.data;
            this.syncLessonPlansToDB(lessonPlansToSync);
          }
          else {
            this.proceedSync();
          }
        }
        else {
          this.setState({confirmId:3})
          this.showAlertDialog(respData.data.message);   
        }        
      },
      error => {
        //this.alertService.error(error);
        console.log(error);
        this.setState({confirmId:2})
        this.connectionError();
      }
    );
  }

  syncLessonPlansToDB(lessonPlansToSync: Array<LessonPlan>) {
    console.log('syncLessonPlansToDB()...');
    this.lessonplanservice.addLessonPlans(lessonPlansToSync).then(data => {              
        console.log("syncLessonPlansToDB : successCB...")
        this.syncLessonPlanStepStatus();
      },
      error => {
        this.setState({confirmId:3})
        this.showAlertDialog('Sync Lessonplans Error:'+ error); 
        console.log('Sync Lessonplans Error:'+ error);
      }
    );
  }

  syncLessonPlanStepStatus() {
    console.log('syncLessonPlanStepStatus()...');
    this.setState({loadingProgress : this.state.loadingProgress+10});
    this.setState({loadingText:"Synchronizing Lesson Plan Steps..."});
    ApiService.syncLessonPlanStepStatus(this.instructorId)
    .then(
      respData => {
        /*
          "data":[
            {"id":1,"lessonPlanId":298,"stepId":25,"batchId":219,
            "completedById":114,"statusTypeId":2,"completedDate":null,"startedDate":"15/7/19", "syncStatus":1}
          ]
        */
        console.log('syncLessonPlanStepStatus(), Response : '+JSON.stringify(respData.data));
        if(respData.data.status==1) {
          if(respData.data.data.length>0) {
            let lessonPlanStepStatusesToSync: Array<LessonPlanStepStatus> = respData.data.data;
            this.syncLessonPlanStepStatusToDB(lessonPlanStepStatusesToSync);
          }
          else {
            this.setState({confirmId:10})
            this.showAlertDialog(`${respData.data.message} no lesson plan step found`);   
          }        
        }
        else {
          this.setState({confirmId:3})
          this.showAlertDialog(respData.data.message);   
        }        
      })
      .catch(
      error => {
        //this.alertService.error(error);
        console.log(error.message);
        this.setState({confirmId:2})
        this.connectionError();
      }
    );
  }

  syncLessonPlanStepStatusToDB(lessonPlanStepStatusesToSync: Array<LessonPlanStepStatus>) {
    console.log('syncLessonPlanStepStatusToDB()...');
    this.lessonplanservice.addLessonPlanStepStatuses(lessonPlanStepStatusesToSync).then(data => {              
        console.log("syncLessonPlanStepStatusToDB : successCB...")
        this.proceedSync();
      },
      error => {
        this.setState({confirmId:3})
        this.showAlertDialog('Sync LessonPlanStepStatus Error:'+ error); 
        console.log('Sync LessonPlanStepStatus Error:'+ error);
      }
    );
  }

  public showAlertDialog(message: string) {
    this.setState({showAlert:true,alertMessage:message})
    // if(confirmed) console.log('User confirmed:', confirmed)
    // else console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)');
  }

  public connectionError() {
    //public CONNECTION_ERROR_MSG:string ="The server is taking too long to respond OR something is wrong with your internet connection. Please try again later." 
    this.setState({showAlert:true,alertMessage:Config.CONNECTION_ERROR_MSG})
    // if(confirmed) console.log('User confirmed:', confirmed)
    // else console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)');
  }

  syncSuccess() {
    this.setState({loadingText:"Synchronizing Done Successfully."})
    setTimeout(() => { 
      this._dismiss();     
    }, 5000);
  }
  handleAlert(flag)
  {
    this.setState({showAlert:false})
    if(this.state.confirmId === 10)
    {
      this.proceedSync()
    }
    else if(this.state.confirmId === 2)
    {
      this.props.history.goBack()
    }
  }
  public _dismiss() {
    this.props.history.goBack();  
  }

  render(){
      return(
        <div className="app flex-row align-items-center">
          {this.state.showAlert && <AlertDialog message={this.state.alertMessage} title="Alert" btnOkText="OK" size="sm" close={this.handleAlert} />}
        <div className="container">
            <div className="card-group">
                <div className="card text-center border-info full-height1">
                    <div className="card-header pageheading bg-info text-white">
                        <FontAwesomeIcon icon={faArrowLeft} size="lg" className="float-left" onClick={() => this._dismiss()}></FontAwesomeIcon>
                        <b>Sync-In</b>
                    </div>
                    <div className="card-body">
                        <div>{this.state.loadingText}</div>
                        <div className="progress">
                            <div className="progress-bar" role="progressbar"
                                // attr.aria-valuenow={this.state.loadingProgress} 
                                aria-valuemin={0} 
                                aria-valuemax={100}
                                style={{width:`${this.state.loadingProgress}%`}}
                            >
                                {this.state.loadingProgress}%
                            </div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
    </div>
      )
  }

}
